import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, Validators} from '@angular/forms';
import {HttpService} from '../../../../../core';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-add-lot-dialog',
  templateUrl: './add-lot-dialog.component.html',
  styleUrls: ['./add-lot-dialog.component.scss']
})
export class AddLotDialogComponent implements OnInit {

  project: any;
  form: any;
  isSubmitted: any;

  constructor(private fb: FormBuilder,
              private httpService: HttpService,
              private toastrService: ToastrService,
              private dialogRef: MatDialogRef<any>,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      lotNumber: ['', [Validators.required]],
      lotSize: ['', [Validators.required]],
      width: [0],
      length: [0],
      price: ['', [Validators.required]],
      stage: [''],
      status: ['', [Validators.required]],
      parkFront: [''],
      lakeFront: [''],
      cornerBlock: [''],
      projectId: [''],
    });
  }

  ngOnInit(): void {
    this.project = this.data.project;
  }

  /**
   * @author Damon Gao
   */
  buildFormData() {
    const fd = new FormData();
    const fieldsToAppend = [
      'lotNumber',
      'lotSize',
      'width',
      'length',
      'price',
      'status'];
    fieldsToAppend.forEach(field => {
      fd.append(field, this.form.get(field).value);
    });
    ['stage', 'parkFront', 'lakeFront', 'cornerBlock'].forEach(field => {
      const value = this.form.get(field).value;
      if (value !== '') {
        fd.append(field, value);
      }
    });
    fd.append('projectId', this.project.id);
    return fd;
  }

  /**
   * @author Damon Gao
   * @param res response
   */
  handleResponse(res: any) {
    if (res.code === 1) {
      this.toastrService.success('One lot has been added.');
      this.dialogRef.close({
        newLot: res.data,
        buildingId: this.project.id,
      });
    } else {
      this.toastrService.error('Failed to add lot.');
    }
  }

  /**
   * @author Damon Gao
   */
  createLot() {
    this.isSubmitted = true;
    const fd = this.buildFormData();
    this.httpService.createLot(fd).subscribe((res: any) => {
      this.handleResponse(res);
    });
  }

  handleClose() {
    this.dialogRef.close();
  }
}
